import React from "react";
import { Navigate } from "react-router-dom";

import { USER_TYPE } from "../constants/common";

const RoleBasedRedirect = ({ element: Component, role, lang, ...rest }) => {
  if (!role) {
    return <Component {...rest} />;
  }

  // Special case for student role
  if (role === USER_TYPE.STUDENT.ROLE) {
    return <Navigate to={`/${lang}/${role}/learning-area`} replace />;
  }

  // Default redirection for other roles
  return <Navigate to={`/${lang}/${role}`} replace />;
};

export default RoleBasedRedirect;
